import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export default function Preloader({ onDone }) {
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem("domo-seen")) { setDone(true); onDone?.(); return; }
    const end = setTimeout(() => { setDone(true); sessionStorage.setItem("domo-seen", "1"); onDone?.(); }, 1900);
    return () => clearTimeout(end);
  }, [onDone]);
  return (
    <AnimatePresence>
      {!done && (
        <motion.div className="pre" exit={{ y: "-100%" }} transition={{ duration: 1.1, ease: EASE }}>
          <div className="pre-inner">
            <motion.span className="pre-jp" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .8, ease: [0.16, 1, 0.3, 1], delay: .1 }}>どうも</motion.span>
            <motion.span className="pre-en" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: .8, delay: .7 }}>Thank you for coming.</motion.span>
            <motion.div className="pre-bar" initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 1.6, ease: "linear" }} />
          </div>
          <style dangerouslySetInnerHTML={{ __html: `
            .pre { position: fixed; inset: 0; z-index: 10000; background: var(--sumi); display: grid; place-items: center; }
            .pre-inner { display: grid; gap: 18px; justify-items: center; }
            .pre-jp { font-family: var(--serif); font-size: clamp(3rem, 8vw, 7rem); color: var(--washi); line-height: 1; letter-spacing: .1em; }
            .pre-en { font-family: var(--serif); font-style: italic; color: var(--ash); font-size: 1.1rem; }
            .pre-bar { width: 140px; height: 1px; background: var(--shu); transform-origin: left; margin-top: 10px; }
          ` }} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
